import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'normalize.css'
import 'element-ui/lib/theme-chalk/display.css';
import router from './router'
import axios from './utils/http'
import store from './store'; // 引入 Vuex store 
import 'hover.css'
import * as echarts from "echarts";//echarts
import '../src/assets/css/indexElement.scss'//element自定义全局样式
import { BackTop,Affix,Button, Menu, MenuItem, Card, Row, Col, Tag, Tabs, TabPane, Form, FormItem, Input, CheckboxGroup, Checkbox, Select, Option, RadioGroup, Radio, Cascader } from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.component('Button', Button);
Vue.component('Menu', Menu);
Vue.component('MenuItem', MenuItem);
Vue.component('Card', Card);
Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Tag', Tag);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Input', Input);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Checkbox', Checkbox);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Radio', Radio);
Vue.component('Cascader', Cascader);
Vue.component('BackTop', BackTop);
Vue.component('Affix', Affix);
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;

import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
Vue.use(mavonEditor)
Vue.prototype.axios = axios
// import HittikModal from './components/hitick/index.vue'
import api from './api'

// Vue 2 挂载方式
Vue.prototype.$api = api
// const ModalConstructor = Vue.extend(HittikModal)
// const instance = new ModalConstructor().$mount()
// document.body.appendChild(instance.$el)
new Vue({
  router,
  beforeCreate:() => {
    Vue.prototype.$bus = this
  },
  render: h => h(App),
  store,  // 将 store 添加到 Vue 实例中  
}).$mount('#app')
